import { navigationComponentsConfig } from 'navigation-components/config';
import { NavigationComponents } from 'navigation-components/platform/components';
import { useCallback } from 'react';
import { useAppSelector } from '../hooks/redux';
import { selectGates } from '../reducers/Portal';
import { getNavStartTime } from '../utils/navStartTime';
import { captureException } from '../utils/sentryAPI';
import { jsx as _jsx } from "react/jsx-runtime";
export const NavigationComponentsProvider = ({
  disableRenderingForTests,
  children
}) => {
  const gates = useAppSelector(selectGates);
  const enableScheduler = !('jasmine' in window);
  const schedulerOptions = {
    useDeferInitially: gates.includes('nav:deferred-scheduler')
  };
  const onError = useCallback(error => {
    const extra = {};
    if (error.cause instanceof Error) {
      extra.cause = {
        error: error.cause,
        message: error.cause.message,
        stack: error.cause.stack
      };
    }
    captureException(error, {
      tags: {
        errorBoundaryName: 'NavigationComponents'
      },
      extra
    });
  }, []);
  return /*#__PURE__*/_jsx(NavigationComponents, {
    config: navigationComponentsConfig,
    gates: gates,
    disableRenderingForTests: disableRenderingForTests,
    metricsStartTime: getNavStartTime(),
    enableScheduler: enableScheduler,
    schedulerOptions: schedulerOptions,
    onError: onError,
    children: children
  });
};